











































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { AccountAsset } from '@/modules/AccountAsset/interfaces/account-asset'
import AccountVehicleDialog from '@/modules/AccountAsset/scripts/asset-vehicle-dialog'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class AccountAssetDetailDetail extends mixins(AccountVehicleDialog) {
  @Prop({ type: Object as () => AccountAsset }) readonly accountAsset!: AccountAsset

  dollarFilter = dollarFilter

  get vehicle () {
    return this.accountAsset.vehicle || {}
  }

  get notes () {
    if (!this.accountAsset) return []
    return this.accountAsset.notes.split('\n')
  }
}
